import React from "react";

const Round = (props) => {
  const viewBoxWidth = 96;
  const viewBoxHeight = 86;

  const lengthXPrcnt = 0.22;
  const lengthYPrcnt = 0.63;

  const widthXPrcnt = 0.56;
  const widthYPrcnt = 0.23;

  const lengthX = lengthXPrcnt * viewBoxWidth;
  const lengthY = lengthYPrcnt * viewBoxHeight;

  const widthX = widthXPrcnt * viewBoxWidth;
  const widthY = widthYPrcnt * viewBoxHeight;

  const lineColor = "#4a4a4a";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={"-1.696 -0.4 " + viewBoxWidth + " " + viewBoxHeight}
      width={props.width}
      height={props.height}
      preserveAspectRatio={props.preserveAspectRatio}
    >
      <path
        fill={props.color}
        stroke={props.color}
        strokeWidth={props.stroke_width}
        d="M85.2,42.8c0-30-30.6-50.7-58.5-39.1C16.4,7.9,8.1,16.2,3.8,26.6l0,0c-4.3,10.3-4.3,22.1,0,32.4
		c11.5,27.8,47.7,35.1,69,13.7C80.7,64.8,85.2,54.2,85.2,42.8z M14.4,72.8c11.5-0.6,14.3-0.8,15.9-0.9l-3.7,8.9
		C22.1,78.9,18,76.2,14.4,72.8z M12.9,71.3c-3.4-3.6-6.1-7.7-8.1-12.2c5-2.1,2.6-1.1,8.9-3.7C13.4,63,13.3,63.7,12.9,71.3z
		 M84.1,42.8c-4.6,4.1-7.8,6.9-12.4,11.1c-1.3-2.3-4.1-7.6-6-11.1c3-5.6,2.8-5.1,6-11.1C79.1,38.3,79.3,38.5,84.1,42.8z M57.9,26.3
		c-4.9-2-9-3.7-13.9-5.8l10.5-5.7L57.9,26.3z M58.2,27.4c5.4,13,4,9.6,6.3,15.3c-2.4,5.7-1,2.3-6.3,15.3c-13,5.4-9.6,4-15.3,6.4
		c-5.7-2.4-2.3-1-15.3-6.3c-5.4-13-4-9.6-6.3-15.3c2.4-5.7,1-2.3,6.3-15.3c8.9-3.7,7.1-2.9,15.3-6.3C51.1,24.5,49.3,23.7,58.2,27.4z
		 M57.9,59.2l-3.4,11.4L44,64.9C49.3,62.8,52.9,61.3,57.9,59.2z M20.7,41.7L15,31.2l11.5-3.4C24.4,32.7,22.9,36.4,20.7,41.7z
		 M26.4,57.7l-11.5-3.4l5.7-10.5C22.8,49.1,24.4,52.8,26.4,57.7z M31.3,14.8l10.5,5.7c-8.2,3.4-5.4,2.2-13.9,5.8
		C32.1,12.2,30.8,16.8,31.3,14.8z M31.3,70.7c-0.5-1.8,0-0.1-3.4-11.4c8.5,3.5,5.4,2.2,13.9,5.8C35.5,68.5,37.8,67.2,31.3,70.7z
		 M70.8,54.3l-11.4,3.4c2-4.9,3.7-9,5.8-13.9C67.1,47.5,68.6,50.2,70.8,54.3z M65.2,41.7c-0.8-2-4.6-11-5.8-13.9
		c2.9,0.9,8.5,2.5,11.4,3.4C67.4,37.5,67.3,37.8,65.2,41.7z M71.1,30.3L59,26.7l-3.6-12.1L72,13.7C71.6,21.9,71.6,21.2,71.1,30.3z
		 M20.2,42.8l-6,11.1L1.8,42.8l12.4-11.1L20.2,42.8z M26.9,58.8c2.8,9.4,0.8,2.8,3.6,12.1l-16.6,0.9l0.9-16.6L26.9,58.8z M42.9,65.5
		l11.1,6L42.9,83.9L31.8,71.5L42.9,65.5z M59,58.8c3.1-0.9,9-2.7,12.1-3.6c0.5,8.9,0.5,8.6,0.9,16.6l-16.6-0.9L59,58.8z M72,30.2
		l0.9-15.9C76.3,17.9,79,22,81,26.5L72,30.2z M54,14c-5.9,3.2-5.3,2.9-11.1,6c-18-9.8-7.9-4.3-11.1-6c3.8-4.2,6.7-7.4,11.1-12.4
		C48.3,7.6,45.2,4.2,54,14z M30.4,14.6l-3.6,12.1l-12.1,3.6l-0.9-16.6C19.7,14,24.1,14.2,30.4,14.6z M13.8,30.2
		c-6.4-2.6-4-1.6-8.9-3.7C6.8,22,9.6,17.8,13,14.3C13.3,21.8,13.4,22.6,13.8,30.2z M31.2,72.2c4.7,5.2,8.7,9.7,10.7,11.9
		c-5-0.1-9.8-1.1-14.4-3L31.2,72.2z M72,55.3l8.9,3.7c-1.9,4.5-4.7,8.7-8.1,12.2L72,55.3z M81.3,58.2c-3.3-1.4-5.6-2.3-8.9-3.7
		c4.1-3.6,4.5-4.1,11.9-10.7C84.2,48.8,83.2,53.6,81.3,58.2z M72.4,31.1c3.4-1.4,5.6-2.3,8.9-3.7c1.8,4.6,2.8,9.4,3,14.4
		C80.7,38.5,75.9,34.2,72.4,31.1z M55.5,13.6c0.6-1.5,2.2-5.4,3.7-8.9c4.5,1.9,8.7,4.6,12.2,8.1L55.5,13.6z M58.3,4.3
		c-1.4,3.3-2.3,5.6-3.7,8.9C51,9.2,50.5,8.7,44,1.4C48.9,1.5,53.8,2.5,58.3,4.3z M31.2,13.3l-3.7-8.9c4.6-1.8,9.4-2.8,14.4-3
		L31.2,13.3z M26.6,4.7l3.7,8.9c-4-0.2-11.8-0.6-15.9-0.9C18,9.4,22.1,6.6,26.6,4.7z M4.5,27.4l8.9,3.7C7.9,36,7.2,36.6,1.5,41.8
		C1.7,36.7,2.7,31.9,4.5,27.4z M13.4,54.5l-8.9,3.7c-1.8-4.6-2.8-9.4-2.9-14.4C6.5,48.3,7.7,49.3,13.4,54.5z M54.6,72.2l3.7,8.9
		c-4.6,1.8-9.4,2.8-14.4,3C53.5,73.5,51.6,75.7,54.6,72.2z M59.2,80.8l-3.7-8.9c3.3,0.2,10.9,0.6,15.9,0.9
		C67.8,76.2,63.7,78.9,59.2,80.8z"
      />
      {props.show_diagram && (
        <>
          <line
            x1="30"
            y1="0"
            x2="30"
            y2="85"
            stroke={lineColor}
            strokeWidth=".5"
          ></line>
          <line
            x1="28"
            y1="0"
            x2="32"
            y2="0"
            stroke={lineColor}
            strokeWidth=".5"
          ></line>
          <line
            x1="28"
            y1="85"
            x2="32"
            y2="85"
            stroke={lineColor}
            strokeWidth=".5"
          ></line>
          <rect
            x={lengthX}
            y={lengthY}
            width="20"
            height="11"
            rx="0.8"
            fill="white"
          ></rect>
          <text
            x={lengthX + 2}
            y={lengthY + 4}
            fontSize=".4rem"
            stroke={lineColor}
            strokeWidth="0.01"
          >
            Length:
          </text>
          <text
            x={lengthX + 1}
            y={lengthY + 10}
            fontSize=".4rem"
            stroke={lineColor}
            strokeWidth="0.01"
          >
            {props.diamond.Measurement1}
          </text>

          <line
            x1="2"
            y1="25"
            x2="90"
            y2="25"
            stroke={lineColor}
            strokeWidth=".5"
          ></line>
          <line
            x1="2"
            y1="23"
            x2="2"
            y2="27"
            stroke={lineColor}
            strokeWidth=".5"
          ></line>
          <line
            x1="90"
            y1="23"
            x2="90"
            y2="27"
            stroke={lineColor}
            strokeWidth=".5"
          ></line>

          <rect
            x={widthX}
            y={widthY}
            width="19"
            height="11"
            rx="0.8"
            fill="white"
          ></rect>
          <text
            x={widthX + 2}
            y={widthY + 4}
            fontSize=".4rem"
            stroke={lineColor}
            strokeWidth="0.01"
          >
            Width:
          </text>
          <text
            x={widthX + 1}
            y={widthY + 10}
            fontSize=".4rem"
            stroke={lineColor}
            strokeWidth="0.01"
          >
            {props.diamond.Measurement2}
          </text>
        </>
      )}
    </svg>
  );
};

export default Round;
